"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GenericThumbnail = void 0;
var react_1 = __importDefault(require("react"));
var VideoThumbnail_1 = require("Project/ContentSidebar/Explore/Video/VideoThumbnail");
var BlockThumbnail_1 = require("Project/ContentSidebar/Explore/Blocks/BlockThumbnail");
var UnsplashImageCard_1 = __importDefault(require("Project/ContentSidebar/Explore/Image/UnsplashImage/UnsplashImageCard"));
var Types_1 = require("Project/ContentSidebar/Explore/Types");
var SidebarExploreContext_1 = require("Project/ContentSidebar/Explore/SidebarExploreContext");
var inversify_react_1 = require("inversify-react");
var GenericThumbnail = function (_a) {
    var asset = _a.asset, onClick = _a.onClick, onDragStart = _a.onDragStart, onDragEnd = _a.onDragEnd;
    var store = (0, SidebarExploreContext_1.useSidebarExploreContext)().blockExploreDataStore;
    var thumbnailApiBaseUrl = (0, inversify_react_1.useInjection)("thumbnailApiBaseUrl");
    if ((0, Types_1.isAssetVideo)(asset)) {
        return (react_1.default.createElement(VideoThumbnail_1.VideoThumbnail, { key: asset.content.thumbnail, asset: asset, onClick: onClick, onDragStart: onDragStart, onDragEnd: onDragEnd }));
    }
    else if ((0, Types_1.isAssetBlock)(asset)) {
        return (react_1.default.createElement(BlockThumbnail_1.BlockThumbnail, { key: asset.content.id, asset: asset, onClick: onClick, onDragStart: onDragStart, onDragEnd: onDragEnd, thumbnailImage: store.getThumbnailUrl(thumbnailApiBaseUrl, asset.content.id) }));
    }
    else if ((0, Types_1.isAssetUnsplash)(asset)) {
        return (react_1.default.createElement(UnsplashImageCard_1.default, { key: asset.content.id, asset: asset, onClick: onClick, onDragStart: onDragStart, onDragEnd: onDragEnd }));
    }
    else {
        return react_1.default.createElement(react_1.default.Fragment, null);
    }
};
exports.GenericThumbnail = GenericThumbnail;
